<template>
    <b-tabs class="d-flex flex-column">
        <b-tab>
            <template v-slot:title>
                Allocated &nbsp;<b-badge variant="primary">{{ allocationsList.length }}</b-badge>
            </template>
            <allocated-tab :salesOrderLineId="salesOrderLineId" :reqLineId="reqLineId" @refreshAvailableParts="getAvailableParts(partId)" />
        </b-tab>        
        <b-tab>
            <template v-slot:title>
                On-Hand &nbsp;<b-badge variant="primary">{{ onHand.length }}</b-badge>
            </template>
            <on-hand-tab :partId="partId" :reqLineId="reqLineId" :salesOrderLineId="salesOrderLineId" @refreshAvailableParts="getAvailableParts(partId)" @on-hand-counts="onHandInventoryCounts = $event" />
        </b-tab>
        <b-tab v-if="salesOrderLineId > 0">
            <template v-slot:title>
                Discrepancy &nbsp;<b-badge variant="primary">{{discrepanciesList.length}}</b-badge>
            </template>
            <discrepancy-tab :salesOrderLineId="salesOrderLineId" @refreshAvailableParts="getAvailableParts(partId)" />
        </b-tab>
    </b-tabs>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AllocatedTab from './Allocated';
import DiscrepancyTab from './Discrepancy';
import OnHandTab from './OnHand';

export default {
    components: {
        AllocatedTab,
        DiscrepancyTab,
        OnHandTab
    },
    props: {
        reqLineId: {
            type: [Number, String],
            default: 0
        },
        salesOrderLineId: {
            type: [Number, String],
            default: 0
        },
        partId: {
            type: [Number, String],
            default: 0,
        }
    },
    computed: {
        ...mapGetters('inventory', ['allocationsList', 'discrepanciesList', 'inventoryListForPartById']),
        onHand() {
            let onHands = this.inventoryListForPartById(this.partId).filter(x => x.onHand > 0 && [1, 4].includes(x.sourceId));
            
            return onHands;
        },
    },
    methods: {
        ...mapActions('inventory', ['getInventoryAvailableParts']),
        getAvailableParts(partId) {
            this.getInventoryAvailableParts(partId)
            this.$emit('on-refresh-list');
        }
    }
}
</script>

<style>

</style>